// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3i8CV","title":"AfterBackImages_title__2oPJh","images":"AfterBackImages_images__1XGxa"};